import React from "react";
import { useLocation } from "react-router-dom";
import { menuSection, menuButton, menuButtonEn, menuLogo } from "../menuPage.css.ts";
import topLogo from "../../../../../assets/top/top_logo.png";

const menuSections = [
  { id: 'lunchmenu', label: 'ランチ', en: 'LUNCH' },
  { id: 'dinnermenu', label: '夜ムク', en: 'DINNER' },
  { id: 'takeoutmenu', label: 'テイクアウト', en: 'TAKEOUT' },
  { id: 'reservation', label: '予約', en: 'RESERVATION', href: 'https://app.squareup.com/appointments/book/qgq7fvn533lm8i/LDWB4KMXMDB4D/start' },
  { id: 'top', label: 'トップへ', en: 'TOP' },
];

const MenuSection: React.FC = () => {
  const location = useLocation();

  const isActive = (id: string) => {
    return location.pathname === `/${id}`;
  };

  const handleClick = (id: string, href?: string) => {
    if (href) {
      window.location.href = href;
      return;
    }
    if (id === "top") {
      window.location.href = "/";
    } else {
      window.location.href = `/${id}`;
    }
  };

  return (
    <div className={menuSection}>
      <img
        src={topLogo}
        alt="キッチンムク"
        className={menuLogo}
        style={{ cursor: "pointer" }}
        onClick={() => handleClick("top")}
      />
      {menuSections.map((section) => (
        <button
          key={section.id}
          className={menuButton}
          onClick={() => handleClick(section.id, section.href)}
        >
          <span style={{ fontWeight: isActive(section.id) ? 'bold' : 'normal' }}>{section.label}</span>
          <span className={menuButtonEn}>{section.en}</span>
        </button>
      ))}
    </div>
  );
};

export default MenuSection; 